import { CheckoutAttribute } from '../../models/checkout/checkout-attribute.interface';

export const mockCheckoutAttribute: CheckoutAttribute = {
  itemIterationId: 1,
  netAmount: 4.99,
  periodOfCover: 12,
  effectiveDate: '2025-01-03',
};
